import { render, staticRenderFns } from "./cardResult.vue?vue&type=template&id=e9714f56&scoped=true"
import script from "./cardResult.vue?vue&type=script&lang=js"
export * from "./cardResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9714f56",
  null
  
)

export default component.exports